import React, { useState, useRef, useEffect } from "react";
import Cropper from 'react-cropper';
import { Modal, Row, Col, Button } from "antd";
import { useWatchState } from "@/store";
import { debounce, base64ToImage } from "@/utils";
import 'cropperjs/dist/cropper.css';

const NAME = "cropper";

const View = () => {

    const [[{ title = "图像裁切", show, hide, width = 1050, img, imageWidth = 100, imageHeight = 100, callback = () => { } }]] = useWatchState(["modal." + NAME])

    const canvas = useRef(null);
    let [ctx, setCtx] = useState(null);

    const cropper = useRef(null);
    const [preview, setPreview] = useState("");

    // 裁切事件
    const _crop = debounce(async () => {
        if (cropper) {
            if (!ctx) {
                ctx = canvas.current.getContext("2d");
                setCtx(ctx);
            }
            setPreview(cropper.current.getCroppedCanvas().toDataURL());
        }
    })

    // 监听裁切后的 base64
    useEffect(() => {
        // 转成图片
        base64ToImage(preview, img => {
            // polyfill 提供了这个方法用来获取设备的 pixel ratio
            // var getPixelRatio = function (context) {
            //     var backingStore = context.backingStorePixelRatio ||
            //         context.webkitBackingStorePixelRatio ||
            //         context.mozBackingStorePixelRatio ||
            //         context.msBackingStorePixelRatio ||
            //         context.oBackingStorePixelRatio ||
            //         context.backingStorePixelRatio || 1;

            //     return (window.devicePixelRatio || 1) / backingStore;
            // };

            // var ratio = getPixelRatio(ctx);
            // 绘制到 canvas 中
            ctx.drawImage(img, 0, 0, imageWidth, imageHeight);
        })
    }, [preview])

    // 提交事件
    const finish = () => {
        // 将 canvas 转为 base64
        var base64 = canvas.current.toDataURL("image/jpeg");
        callback(base64)
    }

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={(
                <div className="flex row-end child-left--small">
                    <Button type="primary" onClick={finish}>完成</Button>
                    <Button onClick={hide}>取消</Button>
                </div>
            )}
        >
            <Row style={{ width: "1000px" }}>
                <Col span={12}>
                    <Cropper
                        ref={cropper}
                        src={img}
                        style={{ height: 400 }}
                        aspectRatio={imageWidth / imageHeight}
                        guides={false}
                        crop={_crop} />
                </Col>
                <Col span={12}>
                    <div className="flex">
                        <canvas ref={canvas} width={imageWidth} height={imageHeight}></canvas>
                    </div>
                    <div style={{ display: "inline-block" }}>
                        <img src={preview} width={imageWidth} height={imageHeight} />
                    </div>
                </Col>
            </Row>
        </Modal>
    );
}

export default View;